import { render, staticRenderFns } from "./AlertRemindThankYou.vue?vue&type=template&id=0841d582&"
import script from "./AlertRemindThankYou.vue?vue&type=script&lang=js&"
export * from "./AlertRemindThankYou.vue?vue&type=script&lang=js&"
import style0 from "./AlertRemindThankYou.vue?vue&type=style&index=0&id=0841d582&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports